import { getName, humanizeKey } from 'admin/helpers'
import { useLink } from 'admin/helpers/getLink'

import DisplayCard from './DisplayCard'

const Card = ({ model, title, subtitle, note, to, ...rest }) => {
  const modelLink = useLink(model)
  const $to = to || modelLink || '#'

  const $title = title || getName(model)

  const $subtitle = subtitle || humanizeKey(model?.object)
  const $note = note || model?.id

  return <DisplayCard note={$note} subtitle={$subtitle} title={$title} to={$to} {...rest} />
}

export default Card
